import { z } from 'zod';
import { FolderType } from '../enums';

export { FolderType };

export const FolderTypeSchema = z.nativeEnum(FolderType);

export type FolderTypeEnum = z.infer<typeof FolderTypeSchema>;

export const FolderSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  name: z.string(),
  folder_type: FolderTypeSchema,
  sort_order: z.number().int(),
  parent_id: z.string().uuid().nullable().optional(),
  created_at: z.string().datetime(),
  item_count: z.number().int().optional(),
  children_count: z.number().int().optional(),
});

export type Folder = z.infer<typeof FolderSchema>;
